import React, { useState } from 'react';
import NoCreditsImg from '../assets/NoCredits.svg'
import { useNavigate } from 'react-router-dom';
import Warning from '../assets/iconoAtencion.svg'
import './noCredits.css'
import Navbar from '../../../../navbar/menuVertical/navbar';

const NoCredits = () => {
  const [navbarData, setNavbarData] = useState(false);
  const navigate = useNavigate();

  const estadoMenu = (data) => {
    setNavbarData(data);
  };

  return (
    <>
      <div className="containerAmplify ">
        <Navbar estado={estadoMenu} />

        <div
          className={`amplify_body_container ${navbarData ? "navbar-open" : ""}`}
          style={{ marginLeft: navbarData ? "228px" : "80px" }}
        >
          <main className="mainAmplify">
            {/* Titulo */}


            <div className='amplifyModalTablaNoCreditsGeneral borde-radius-gris'>
              <div className='amplifyModalContentImg'>
                <div className="imgModalExitoNoCredits">
                  <img src={NoCreditsImg} alt="exito" />
                </div>
                <div className='amplifyModalTablaNoCreditsContainer'>
                  <div className='amplifyModalTablaNoCredits'>
                    <img src={Warning} alt="Imagen de advertencia" />
                    <h2>¡Vaya! No dispones de créditos</h2>
                  </div>
                  <p className='modalNoCreditsText'>No tienes suficientes créditos para procesar esta solicitud. Por favor, contáctacte con nuestro equipo de soporte para adquirir más créditos y finalizar este proceso.</p>
                </div>
              </div>
              <div className='ConfirmacionBotonesNoCreditsContainer'>
                <button className={'ConfirmacionBotonesNoCredits'} onClick={() => { navigate('/inicio/amplify') }}>Volver atrás</button>
              </div>

            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default NoCredits;
